import { post } from '@services/method';
import routes from '@configs/routes.json';
import { formatPostRequest } from '@hooks/api/utilities';

import { IAPIOrderDetails } from '@models';

const paths = {
  details: routes.api.ordertests.search,
  downloadPackage: routes.api.reports.createPackage,
};

export const useOrdersAPI = () => {
  const getDetails = async (orderNumber: string) => {
    const params = {
      orderNumber: orderNumber,
    };
    const headers = {
      'Content-Type': 'application/json',
    };
    const options = formatPostRequest(params, headers);

    const response: IAPIOrderDetails = await post(paths.details, options)
      .then((resp) => resp.json())
      .catch((e) => {
        console.error(e);
      });
    return response;
  };

  const downloadReports = (documentType: string[], orderTestIds: string[]) => {
    const params = {
      documentTypes: documentType,
      orderTestIds: orderTestIds,
    };
    const headers = {
      'Content-Type': 'application/json',
      'Response-Type': 'document',
    };

    const options = formatPostRequest(params, headers);

    post(paths.downloadPackage, options);
  };

  const formatDetails = (samples: any[]) => {
    const format = samples.map(
      ({
        orderTestSummary: {
          order: { orderNumber },
          orderTest: { sampleName, testType: type, description },
          specimen: {
            externalSubjectId: patientId,
            specimenNumber: sampleId,
            collectionDate,
          },
          status: { qcStatus, finished: resultDate, status },
        },
        reports,
      }) => ({
        sampleName: sampleName,
        patientId: patientId,
        sampleId: sampleId,
        collectionDate: collectionDate,
        testType: type,
        qcStatus: qcStatus,
        resultDate: resultDate,
        reports: reports,
        status: status,
      })
    );
    return format;
  };

  return {
    downloadReports: downloadReports,
    getDetails: getDetails,
    formatDetails: formatDetails,
  };
};
